import { createSlice } from '@reduxjs/toolkit';
import { addFile, fetchFiles } from '../actions/filesActions';


const filesSlice = createSlice({
    name: 'files',
    initialState: {
      data: [],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchFiles.pending, (state) => {
          state.loading = true;
        })
        .addCase(fetchFiles.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
        })
        .addCase(fetchFiles.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
        .addCase(addFile.pending, (state) => {
          state.loading = true;
        })
        .addCase(addFile.fulfilled, (state, action) => {
          state.loading = false;
          state.data.push(action.payload);
        })
        .addCase(addFile.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    },
  });
  
  export default filesSlice.reducer;
